import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Twitter, Mail } from "lucide-react";
import { ASSETS } from "@/lib/api";

export default function Footer() {
  return (
    <footer className="bg-obsidian border-t border-bone-10 mt-24" data-testid="site-footer">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12 py-16 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2 md:col-span-2">
          <div className="flex items-center gap-3 mb-5">
            <img src={ASSETS.logo} alt="GrailSwag" className="h-12 w-12 object-contain" />
            <span className="font-display text-2xl text-bone">GRAIL<span className="text-imperial">SWAG</span></span>
          </div>
          <p className="text-bone/60 max-w-md text-sm leading-relaxed">
            A limited-edition streetwear house. Every design capped at 500 units. Every drop a collector's chapter.
          </p>
          <div className="flex gap-4 mt-6">
            <a href="#" className="text-bone/60 hover:text-imperial transition-colors" aria-label="Instagram"><Instagram className="w-5 h-5" /></a>
            <a href="#" className="text-bone/60 hover:text-imperial transition-colors" aria-label="Twitter"><Twitter className="w-5 h-5" /></a>
            <a href="mailto:sales@grailswag.com" className="text-bone/60 hover:text-imperial transition-colors" aria-label="Email"><Mail className="w-5 h-5" /></a>
          </div>
        </div>

        <div>
          <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-bone/40 mb-4">Shop</div>
          <ul className="space-y-2">
            <li><Link to="/shop" className="text-bone/80 hover:text-imperial text-sm">All Products</Link></li>
            <li><Link to="/drops/BASQO" className="text-bone/80 hover:text-imperial text-sm">BASQO Drop</Link></li>
            <li><Link to="/drops/BASQET" className="text-bone/80 hover:text-imperial text-sm">BASQET Drop</Link></li>
            <li><Link to="/drops/FIFTYTWO" className="text-bone/80 hover:text-imperial text-sm">FIFTYTWO Drop</Link></li>
          </ul>
        </div>

        <div>
          <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-bone/40 mb-4">House</div>
          <ul className="space-y-2">
            <li><a href="#about" className="text-bone/80 hover:text-imperial text-sm">The Culture</a></li>
            <li><a href="#golden-ticket" className="text-bone/80 hover:text-imperial text-sm">Golden Ticket</a></li>
            <li><Link to="/admin/login" className="text-bone/80 hover:text-imperial text-sm" data-testid="footer-admin-link">Admin</Link></li>
            <li><a href="mailto:sales@grailswag.com" className="text-bone/80 hover:text-imperial text-sm">sales@grailswag.com</a></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-bone-10">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12 py-6 flex flex-col md:flex-row justify-between items-start md:items-center gap-3">
          <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-bone/40">© {new Date().getFullYear()} GrailSwag. All grails reserved.</p>
          <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-bone/40">Limited to 500 units per design. Est. 2026.</p>
        </div>
      </div>
    </footer>
  );
}
